export default "__VITE_ASSET__UlcJJ4d1__"